import React from "react";
import styled from "styled-components";
import {
  ArrowLeft,
  Scale,
  StickyNote,
} from "../HearingBundles/components/Icons.js";
import theme from "../../../../assets/theme";
import { COLORS } from "../HearingBundles/TrailBundle.js";
import _ from "lodash";

export function CaseHeader({
  caseDetails,
  setViewNotes,
  status,
  setFields,
  setOpenHearing,
  setTimelineModal,
  fetchReportDetails = () => {},
  postReportDetails = () => {},
  opendrawer,
  setOpenDrawer,
  viewOnly,
  setClaimValueModal,
}) {
  if (!caseDetails) return null;

  return (
    <Band>
      <TitleRow>
        <BackBtn aria-label="Back to cases">
          <ArrowLeft size={14} />
        </BackBtn>

        <IconBubble>
          <Scale size={14} color="#F6B436" />
        </IconBubble>

        <CaseName>{caseDetails.title}</CaseName>
        {caseDetails?.resolutionKind === "mediation" &&
          caseDetails?.smartODRDisputeId && (
            <ScratchBtn onClick={() => !viewOnly && fetchReportDetails()}>
              <StickyNote size={12} />
              Smart ODR
            </ScratchBtn>
          )}
        {caseDetails?.resolutionKind === "mediation" &&
          caseDetails?.smartODRDisputeId && (
            <ScratchBtn onClick={() => !viewOnly && postReportDetails()}>
              <StickyNote size={12} />
              Trigger Smart ODR
            </ScratchBtn>
          )}
      </TitleRow>

      <SubRow>
        <CaseIdMono>
          {" "}
          <span>
            CASE ID: <ContractNumber>{caseDetails.id}</ContractNumber>
          </span>
        </CaseIdMono>
        <span>·</span>
        <span>
          <span>
            MODE:{" "}
            <ContractNumber>
              {_.startCase(caseDetails.resolutionKind)}
            </ContractNumber>
          </span>
        </span>

        {caseDetails?.loanAccountNo ? (
          <>
            <span>·</span>
            <span>
              Contract Number:{" "}
              <ContractNumber>{caseDetails?.loanAccountNo}</ContractNumber>
            </span>
          </>
        ) : null}
        {caseDetails?.seat ? (
          <>
            <span>·</span>
            <span>
              SEAT:{" "}
              <ContractNumber>{caseDetails?.seat || "Chennai"}</ContractNumber>
            </span>
          </>
        ) : null}
        {caseDetails?.totalClaimValue ? (
          <>
            <span>·</span>
            <span>
              Claim Amount:{" "}
              {viewOnly !== true &&
                caseDetails?.status !== "draft" &&
                caseDetails?.status !== "pendingRegistrationFee" &&
                caseDetails?.status !== "proformaGenerated" &&
                caseDetails?.status !== "waitingForCaseApproval" && (
                  <ClaimAmount onClick={() => setClaimValueModal(true)}>
                    {caseDetails?.totalClaimValue}
                  </ClaimAmount>
                )}
            </span>
          </>
        ) : null}

        {caseDetails?.resolutionKind !== "negotiation" && (
          <>
            <span>·</span>
            <AssignBtn
              onClick={() => setOpenDrawer((a) => ({ ...a, state: true }))}
            >
              Assign View Only
            </AssignBtn>
          </>
        )}

        {/* {...{ setOpenDrawer, caseDetails, setRefreshDetails, viewOnly }}
                id={caseDetails?.id} */}
      </SubRow>
    </Band>
  );
}

const PillRoot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  background: #f3f4f6;
  color: #1f2937;
  border-radius: 9999px;
  white-space: nowrap;
`;

export function Pill({ children, bg, fg, ...rest }) {
  return (
    <PillRoot $bg={bg} $fg={fg} {...rest}>
      {children}
    </PillRoot>
  );
}

const Band = styled.header`
  background: #293462;
  color: #ffffff;
  padding: 12px 16px;
  border-radius: 10px;

  @media (min-width: 768px) {
    padding: 14px 24px;
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const BackBtn = styled.button`
  display: inline-grid;
  place-items: center;
  height: 32px;
  width: 32px;
  border-radius: 6px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

const IconBubble = styled.div`
  height: 28px;
  width: 28px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  background: rgba(246, 180, 54, 0.18);
  color: #f6b436;
  flex-shrink: 0;
`;

const CaseName = styled.h1`
  font-size: 16px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #ffffff;
  line-height: 1.3;
  flex: 1;
  min-width: 0;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const ScratchBtn = styled.button`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  background: rgba(246, 180, 54, 0.12);
  color: #f6b436;
  font-size: 12px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  border: 1px solid rgba(246, 180, 54, 0.3);
  transition: background 120ms;

  &:hover {
    background: rgba(246, 180, 54, 0.2);
  }
`;

const SubRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  font-family: ${theme.fonts.primaryFontRegular};
  color: rgba(255, 255, 255, 0.75);
`;

const CaseIdMono = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  letter-spacing: 0.04em;
`;

const ContractNumber = styled.span`
  color: rgb(246, 180, 54);
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

const ClaimAmount = styled.span`
  color: rgb(246, 180, 54);
  font-family: ${theme.fonts.primaryFontSemiBold};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: ${COLORS.BTN_GREEN};
  }
`;

export const NextHearing = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: ${theme.fonts.primaryFontSemiBold}
  color: ${COLORS.COLOR_DARK}
  cursor: ${(props) => (props.clickable ? "pointer" : "default")};
`;

export const HearingLink = styled.span`
  cursor: ${(props) => (props.clickable ? "pointer" : "default")};
  font-family: ${theme.fonts.primaryFontSemiBold}
  color: ${COLORS.COLOR_DARK}

  &:hover {
    text-decoration: ${(props) => (props.clickable ? "underline" : "none")};
  }
`;

export const UpdateTime = styled.span`
  cursor: pointer;
  font-family: ${theme.fonts.primaryFontSemiBold}
  color: ${COLORS.COLOR_DARK}

  &:hover {
    text-decoration: underline;
  }
`;

export const AssignBtn = styled.button`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 6px;
  background: rgba(246, 180, 54, 0.1);
  color: #f6b436;
  border: 1px solid rgba(246, 180, 54, 0.2);
  font-size: 11px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  transition: all 120ms ease;
  line-height: 1;
  margin-left: 4px;

  &:hover {
    background: rgba(246, 180, 54, 0.18);
    border-color: rgba(246, 180, 54, 0.35);
  }
`;
